import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import ApiConnect from "../../../Utils/ApiConnect";
import { connect } from "react-redux";
import { CustomerCustomersList } from "../../../redux/actions/Modules.Action";
import ReactDatatable from "@ashvin27/react-datatable";
import OrderDetils from "./Components/OrderDetils";
import DispatchLabel from "./Components/DispatchLabel";
import { toast } from "react-toastify";
// import { Link } from "react-router-dom";
class Dispatch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ShowModal: false,
      BookingData: [],
      modalView: "",
    };
    this.columns = [
      {
        key: "id",
        text: "Booking ID",
        cell: (record) => {
          return (
            <a
              href="#_"
              onClick={() => {
                this.setState({
                  showModal: true,
                  modalView: <OrderDetils BookingDetails={record} />,
                });
              }}
            >
              {record.id}
            </a>
          );
        },
      },
      {
        key: "date",
        text: "Date",
        sortable: true,
      },
      {
        key: "total_items",
        text: "Total Items",
        sortable: true,
      },
      {
        key: "total_amount",
        text: "Total Amount",
      },
      {
        key: "payment",
        text: "Payment",
        sortable: true,
      },
      {
        key: "user",
        text: "Order Att",
        cell: (record) => {
          return (
            <div className="avatar-list avatar-list-overlap">
              <a className="avatar" href="#_">
                <img src={record.user.avatar} alt={record.user.name} />
              </a>
              <a className="avatar" href="#_">
                <img
                  src={record.assign_by.avatar}
                  alt={record.assign_by.name}
                />
              </a>
              <a className="avatar avatar-lg" href="#_">
                <img src={record.agent.avatar} alt={record.user.name} />
              </a>
            </div>
          );
        },
      },

      {
        key: "action",
        text: "Action",
        className: "table-actions",
        sortable: false,
        cell: (record, id) => {
          return (
            <React.Fragment key={id}>
              <button
                className="table-action btn btn-square btn-pure hover-success"
                onClick={() => {
                  this.cashReceive(record.id);
                }}
              >
                <span className="material-icons-outlined fs-35">local_atm</span>
              </button>
              <button
                className="table-action btn btn-square btn-pure hover-warning"
                onClick={() => {
                  this.setState({
                    showModal: true,
                    modalView: <DispatchLabel BookingDetails={record} />,
                  });
                }}
              >
                <span className="material-icons-outlined fs-35">print</span>
              </button>
            </React.Fragment>
          );
        },
      },
    ];
    this.config = {
      key_column: "id",
      page_size: 30,
      length_menu: [30, 60, 90],
      show_filter: true,
      show_pagination: true,
      button: {
        // excel: true,
        // print: true
      },
      language: {
        loading_text: "Please be patient while data loads...",
      },
    };
  }
  componentDidMount() {
    this.fetchCustomer();
  }
  fetchCustomer() {
    ApiConnect.get("/Module/Booking/Main/DispatchDetails")
      .then((response) => {
        this.setState({ BookingData: response.data });
      })
      .catch((error) => console.log(error));
  }
  cashReceive(e) {
    ApiConnect.put(`/Module/Booking/Main/PaymentReceive?id=${e}`)
      .then((response) => {
        if (response.data.status === 201) {
          this.fetchCustomer();
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
        } else {
          toast.error(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
  render() {
    return (
      <div className="col-md-12 col-xl-12">
        <div className="card">
          <header className="header no-border">
            <div className="header-info">
              <div className="left">
                <h2 className="header-title">
                  <strong>Order Dispatch</strong>
                </h2>
              </div>
            </div>
            <div className="header-action"></div>
          </header>
          <div className="card-body">
            <div className="dataTables_wrapper">
              <ReactDatatable
                className="table table-separated"
                config={this.config}
                records={this.state.BookingData}
                columns={this.columns}
              />
            </div>
          </div>
          <Modal
            show={this.state.showModal}
            className="modal-center"
            onHide={() => this.setState({ showModal: false })}
          >
            <Modal.Dialog>
              <Modal.Header>
                <h5 className="modal-title">Quick Preview</h5>
                <button
                  type="button"
                  className="btn"
                  onClick={() => this.setState({ showModal: false })}
                >
                  <span className="material-icons-outlined">close</span>
                </button>
              </Modal.Header>
              {this.state.modalView}
            </Modal.Dialog>
          </Modal>
        </div>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    CustomerList: state.Customer.CustomerList,
  }),
  { CustomerCustomersList }
)(Dispatch);
